import { merge } from 'lodash';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import config from 'protections/config/index.js';
import {
    ConfigsService as GeneralConfigService,
    ContentZonesService,
    LocaleService,
    WindowProxy,
} from '@sm360/widget-commons-core-services';
import { AccountService, HistoryService, ModalService } from '@sm360/widget-commons-general';
import { ModelYear, PurchaseMethods, Vehicle } from '@sm360/widget-commons-vehicle';

import { loadQuoteProtections } from 'protections/actions/protectionsActions.js';
import Protections from 'protections/containers/Protections/Protections.js';

import en from 'protections/i18n/en.json';
import fr from 'protections/i18n/fr.json';

import configureStore from 'protections/providers/redux.js';

class ProtectionsProvider extends React.Component {
    constructor(props) {
        super(props);

        merge(en, PurchaseMethods.Translations.en, Vehicle.Translation.en, ModelYear.Translations.en);
        merge(fr, PurchaseMethods.Translations.fr, Vehicle.Translation.fr, ModelYear.Translations.fr);

        GeneralConfigService.setOrganizationId(props.organizationId);
        GeneralConfigService.setOrganizationUnitId(props.organizationUnitId);
        GeneralConfigService.setOrganizationUnitLocation(props.organizationUnitLocation);
        GeneralConfigService.setWebsiteId(props.websiteId);
        GeneralConfigService.setLocation(props.location);

        LocaleService.setLocale(props.locale);
        LocaleService.loadTranslations({ en, fr });

        ContentZonesService.setImageServerBaseUrl(config.source.image);
        ContentZonesService.addContentZones(props.contentZones);

        this.onUnload = this.onUnload.bind(this);

        this.reduxStore = configureStore();

        this.reduxStore.dispatch(loadQuoteProtections(props.quoteId));

        this.forceAuthentication();
    }

    componentDidMount() {
        const $window = WindowProxy.get();

        if ($window) {
            $window.addEventListener('beforeunload', this.onUnload);
        }
    }

    componentWillUnmount() {
        this.onUnload();
    }

    onUnload() {
        HistoryService.add(WindowProxy.location().href);
    }

    onAuthenticationClose() {
        return AccountService.isAuthenticated();
    }

    forceAuthentication() {
        if (!AccountService.isAuthenticated()) {
            const LoginModal = ModalService.get('login/SignUpModal');
            LoginModal.addCallbacks({
                onClose: this.onAuthenticationClose,
            });
            LoginModal.open();
        }
    }

    render() {
        return (
            <Provider store={this.reduxStore}>
                <Protections />
            </Provider>
        );
    }
}

ProtectionsProvider.propTypes = {
    locale: PropTypes.string.isRequired,
    websiteId: PropTypes.number.isRequired,
    organizationUnitId: PropTypes.number.isRequired,
    organizationId: PropTypes.number.isRequired,
    organizationUnitLocation: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    quoteId: PropTypes.string.isRequired,
    contentZones: PropTypes.objectOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                active: PropTypes.bool,
                group: PropTypes.string,
                id: PropTypes.number,
                location: PropTypes.string,
                position: PropTypes.number,
                type: PropTypes.string,
                value: PropTypes.string,
            })
        )
    ).isRequired,
};

ProtectionsProvider.displayName = 'ProtectionsProvider';

export default ProtectionsProvider;



// WEBPACK FOOTER //
// ./src/ProtectionsProvider.jsx